/*
 * NYORD: klebende Kaufleiste (snippets/nb-kaufleiste). Spiegelt den Kaufbereich der Produktseite: gewählte Größe,
 * Preis mit Streichpreis, ausverkauft. Größen-Knöpfe wählen die Variante im echten Variantenwähler (Dawn lädt dann
 * Preis und Knopf neu), der Knopf klickt den echten Warenkorb-Knopf. Sichtbar, solange der Warenkorb-Knopf nicht im
 * Bild ist (am Handy schon beim Seitenstart, weil der Knopf unter der Galerie liegt), ausgeblendet am Seitenende.
 * Liegt die gewählte Variante schon im Warenkorb, zeigen Leiste und Hauptknopf „Zur Kasse“ und führen in den
 * Checkout: vorher legte der nächste Tipp unbemerkt ein zweites Stück hinein (Audit 14.10.2026).
 */
if (!customElements.get('nb-kaufleiste')) {
  customElements.define(
    'nb-kaufleiste',
    class extends HTMLElement {
      connectedCallback() {
        this.bereich = document.querySelector('.nb-pdp .product__info-container');
        if (!this.bereich) return;
        this.knopf = this.querySelector('[data-kaufen]');
        this.knopfText = this.querySelector('[data-knopftext]');
        this.preis = this.querySelector('[data-preis]');
        this.groesse = this.querySelector('[data-groesse]');
        this.werte = [...this.querySelectorAll('[data-wert]')];
        this.imKorb = new Set();
        document.body.classList.add('nb-mit-kaufleiste');

        this.knopf.addEventListener('click', () => {
          if (this.zurKasse) return this.kasse();
          const echt = this.echterKnopf();
          if (echt && !echt.disabled) echt.click();
        });
        // Hauptknopf im Zustand „Zur Kasse“: nicht noch einmal hinzufügen, sondern zur Kasse
        this.bereich.addEventListener(
          'click',
          (e) => {
            const echt = e.target.closest('.product-form__submit[name="add"]');
            if (!echt || !this.zurKasse) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            this.kasse();
          },
          true
        );
        // Warenkorb-Inhalt kennen: beim Laden und nach jeder Änderung (Dawn-Ereignis aus product-form/cart)
        this.korbLaden();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.korbLaden());
        }
        this.werte.forEach((w) =>
          w.addEventListener('click', () => {
            const eingabe = [...this.bereich.querySelectorAll('variant-selects input[type="radio"]')].find((i) => i.value === w.dataset.wert);
            if (!eingabe || eingabe.checked) return;
            this.halten(window.scrollY);
            eingabe.click();
          })
        );

        let geplant = false;
        new MutationObserver(() => {
          if (geplant) return;
          geplant = true;
          requestAnimationFrame(() => {
            geplant = false;
            this.abgleichen();
          });
        }).observe(this.bereich, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'checked'] });
        this.bereich.addEventListener('change', () => setTimeout(() => this.abgleichen(), 50));
        this.abgleichen();
        this.beobachten();
      }

      // Nach einer Auswahl in der Leiste für kurze Zeit die Scrollposition festhalten: Dawn setzt danach den Fokus
      // auf die Größe oben im Kaufbereich, und der Browser würde dorthin springen
      halten(y) {
        clearTimeout(this.haltZeit);
        const zurueck = () => {
          if (Math.abs(window.scrollY - y) > 2) window.scrollTo({ top: y, behavior: 'instant' });
        };
        window.addEventListener('scroll', zurueck, { passive: true });
        document.addEventListener('focusin', zurueck);
        this.haltZeit = setTimeout(() => {
          window.removeEventListener('scroll', zurueck);
          document.removeEventListener('focusin', zurueck);
          zurueck();
        }, 2500);
      }

      echterKnopf() {
        return this.bereich.querySelector('.product-form__submit[name="add"]');
      }

      kasse() {
        window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
      }

      korbLaden() {
        const wurzel = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        fetch(wurzel + 'cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((korb) => {
            this.imKorb = new Set((korb.items || []).map((i) => String(i.variant_id)));
            this.abgleichen();
          })
          .catch(() => {});
      }

      abgleichen() {
        if (this.planen) this.planen();
        const echt = this.echterKnopf();
        const p = this.bereich.querySelector('[id^="price-"] .price');
        let jetzt = '';
        let alt = '';
        if (p) {
          const sale = p.classList.contains('price--on-sale');
          const el = sale ? p.querySelector('.price__sale .price-item--sale') : p.querySelector('.price__regular .price-item--regular');
          jetzt = el ? el.textContent.trim() : '';
          const s = sale ? p.querySelector('.price__sale s .price-item--regular, .price__sale s') : null;
          alt = s ? s.textContent.trim() : '';
        }
        // Nur schreiben, was sich geändert hat: Vitals-Countdown & Co. ändern den Kaufbereich jede Sekunde
        const preisHtml = (alt ? '<s>' + alt + '</s> ' : '') + '<span>' + jetzt + '</span>';
        if (preisHtml !== this.letzterPreis) {
          this.preis.innerHTML = preisHtml;
          this.letzterPreis = preisHtml;
        }
        const aus = !echt || echt.disabled;
        const idFeld = this.bereich.querySelector('form[action*="/cart/add"] [name="id"]');
        this.zurKasse = !aus && !!idFeld && this.imKorb.has(String(idFeld.value));
        if (this.knopf.disabled !== aus) this.knopf.disabled = aus;
        // Texte aus der Sprachdatei (snippets/nb-kaufleiste: data-text-kaufen / data-text-aus / data-text-kasse)
        const kasseText = this.knopf.dataset.textKasse || 'Zur Kasse';
        const text = aus ? this.knopf.dataset.textAus || 'Ausverkauft' : this.zurKasse ? kasseText : this.knopf.dataset.textKaufen || 'In den Warenkorb';
        if (this.knopfText.textContent !== text) this.knopfText.textContent = text;
        // Hauptknopf: Text per CSS ersetzen (Dawn und nb-produkt.js schreiben den Inhalt laufend neu)
        if (echt) {
          if (echt.classList.contains('nb-zur-kasse') !== this.zurKasse) echt.classList.toggle('nb-zur-kasse', this.zurKasse);
          const wert = '"' + kasseText.replace(/"/g, '') + '"';
          if (echt.style.getPropertyValue('--nb-kasse-text') !== wert) echt.style.setProperty('--nb-kasse-text', wert);
        }
        const gewaehlt = this.bereich.querySelector('variant-selects input[type="radio"]:checked');
        if (this.groesse) {
          const g = gewaehlt ? gewaehlt.value.replace('cm', '\u00a0cm').replace(' Liter', '\u00a0L') : '';
          if (this.groesse.textContent !== g) this.groesse.textContent = g;
        }
        const eingaben = [...this.bereich.querySelectorAll('variant-selects input[type="radio"]')];
        this.werte.forEach((w) => {
          const an = String(!!gewaehlt && gewaehlt.value === w.dataset.wert);
          if (w.getAttribute('aria-pressed') !== an) w.setAttribute('aria-pressed', an);
          const eingabe = eingaben.find((i) => i.value === w.dataset.wert);
          const weg = !!eingabe && eingabe.classList.contains('disabled');
          if (w.classList.contains('nb-kaufleiste__wert--aus') !== weg) w.classList.toggle('nb-kaufleiste__wert--aus', weg);
        });
      }

      // Sichtbarkeit aus der Scrollposition (robuster als IntersectionObserver, auch wenn Dawn den Knopf neu rendert)
      beobachten() {
        this.fuss = document.querySelector('footer.footer');
        // Sichtbare Höhe: auf dem iPhone ändert sich die Fensterhöhe mit der Adressleiste, visualViewport stimmt
        const hoehe = () => (window.visualViewport ? window.visualViewport.height : window.innerHeight);
        let geplant = false;
        const pruefen = () => {
          geplant = false;
          const echt = this.echterKnopf() || this.bereich;
          // Den echten Knopf zusätzlich direkt beobachten (Dawn tauscht ihn bei Variantenwechseln aus)
          if (this.io && echt !== this.beobachtet) {
            if (this.beobachtet) this.io.unobserve(this.beobachtet);
            this.io.observe(echt);
            this.beobachtet = echt;
          }
          const r = echt.getBoundingClientRect();
          const h = hoehe();
          // Sichtbar heißt: der Knopf schaut oberhalb der Leiste hervor und steckt nicht unter dem festen Kopf. Sobald er
          // über der Leiste auftaucht, verschwindet sie (sonst zwei Knöpfe übereinander). Etwas Abstand an den Schwellen,
          // damit die Leiste an der Kante nicht hin und her springt.
          const leisteH = this.offsetHeight || 70;
          const rand = this.vorbei ? -12 : 12;
          const imBild = r.height > 0 && r.top < h - leisteH - 10 + rand && r.bottom > 90 - rand;
          this.vorbei = !imBild;
          if (this.fuss) {
            const f = this.fuss.getBoundingClientRect().top;
            if (this.ende) this.ende = f < h + 40;
            else this.ende = f < h - 40;
          }
          this.zeigen();
        };
        const planen = () => {
          if (geplant) return;
          geplant = true;
          requestAnimationFrame(pruefen);
        };
        window.addEventListener('scroll', planen, { passive: true });
        window.addEventListener('resize', planen);
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', planen);
          window.visualViewport.addEventListener('scroll', planen);
        }
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(planen, { threshold: [0, 0.5, 1] });
        }
        // Sicherheitsnetz: solange die Leiste zu sehen ist, jede Dreiviertelsekunde nachprüfen. Auf einem iPhone stand sie
        // sonst einmal neben dem sichtbaren Hauptknopf (Clarity, 14.10.2026).
        setInterval(() => {
          if (this.sichtbar && !document.hidden) planen();
        }, 750);
        this.planen = planen;
        pruefen();
      }

      zeigen() {
        const an = !!this.vorbei && !this.ende;
        if (an === this.sichtbar) return;
        this.sichtbar = an;
        this.classList.toggle('nb-kaufleiste--an', an);
        this.setAttribute('aria-hidden', String(!an));
        this.knopf.tabIndex = an ? 0 : -1;
        this.werte.forEach((w) => (w.tabIndex = an ? 0 : -1));
        document.body.classList.toggle('nb-kaufleiste-sichtbar', an);
      }
    }
  );
}
